
import { Options, Vue } from "vue-class-component";
const LogoFr = require("@/assets/logo-fr.svg");
const LogoEn = require("@/assets/logo-en.svg");
const Logo = require("@/assets/logo.svg");

@Options({
  components: {
  },
  props: {
    hasRoute: {
      type: Boolean,
      default: false
    }
  }
})
export default class LogoMain extends Vue {
  hasRoute: boolean = false;
  route: string = 'Home';

  get routeName() {
    return (!this.hasRoute) ? undefined : this.route;
  }

  get logoPath() : string {
    if (this.$route.name === 'Home') {
      return Logo;
    } else if (this.$i18n.locale === 'fr') {
      return LogoFr;
    } else {
      return LogoEn;
    }
  }

  get logoAlt() : string {
    if (this.$route.name === 'Home') {
      return "Living Memorial Vivant";
    } else if (this.$i18n.locale === 'fr') {
      return "Memorial Vivant";
    } else {
      return "Living Memorial";
    }
  }

  goTo() {
    //this.$router.push({ name: this.route, params: { lang: this.$i18n.locale } });
  }
}
